import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const RegionalLanding = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleCardClick = () => {
    const currentParams = location.search;
    navigate(`/regional-card_detail-corporativo-mobile${currentParams}`);
  };

  const handleSignOut = () => {
    const currentParams = location.search;
    navigate(`/regional-login-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="regional-landing">
      <div className="regional-landing-container">
        {/* Dot Pattern Background */}
        <div className="landing-dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header Section */}
        <div className="landing-header">
          <div className="header-left">
            <div className="user-avatar">
              <img src="/img/avatar-placeholder.png" alt="User" onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="%23E5E7EB"/><circle cx="20" cy="16" r="8" fill="%239CA3AF"/><path d="M4 38c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="%239CA3AF"/></svg>';
              }} />
            </div>
            <span className="welcome-text">WELCOME! Avila Leonel Gaston</span>
          </div>
          <div className="header-right">
            <div className="notification-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <div className="landing-hero-wrapper" style={{ backgroundColor: colors.primario }}>
          <div className="landing-hero">
            <div className="hero-content">
              <h1 className="hero-title">Banking for your future</h1>
              <div className="hero-users">
                <div className="users-avatars">
                  <div className="mini-avatar" style={{ backgroundColor: colors.terciario || '#FF7E7E' }}></div>
                  <div className="mini-avatar" style={{ backgroundColor: colors.terciario || '#FF7E7E' }}></div>
                  <div className="mini-avatar" style={{ backgroundColor: colors.terciario || '#FF7E7E' }}></div>
                </div>
                <span className="users-text">Join +2M users!</span>
              </div>
            </div>
            <div className="hero-image-container">
              <div className="hero-image">
                <img src="/img/imagenCorp.png" alt="Banking" onError={(e) => {
                  e.target.style.display = 'none';
                }} />
              </div>
            </div>
          </div>
        </div>

        {/* Account Card */}
        <div className="landing-account-card">
          <div className="account-card-header">
            <div className="account-info">
              <span className="account-label">Main account</span>
              <span className="account-number">N 4516029658074375</span>
            </div>
            <div className="balance-badge" style={{ backgroundColor: colors.primario }}>
              <span className="balance-amount">$3,996.86</span>
              <span className="balance-currency">USD</span>
            </div>
          </div>
          <div className="account-card-footer">
            <button className="btn-transactions" style={{ color: colors.primario }}>
              Transactions
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="landing-quick-actions">
          <div className="quick-action-item active">
            <div className="quick-action-icon" style={{ backgroundColor: colors.primario }}>
              <div className="icon-circle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="6" width="18" height="14" rx="2" stroke="white" strokeWidth="2"/>
                  <path d="M3 10h18" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
            </div>
            <span className="quick-action-label active" style={{ color: colors.primario }}>Pay Bills</span>
          </div>
          <div className="quick-action-item">
            <div className="quick-action-icon">
              <div className="icon-circle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <span className="quick-action-label">Goals</span>
          </div>
          <div className="quick-action-item">
            <div className="quick-action-icon">
              <div className="icon-circle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="7" height="7" rx="1" stroke={colors.primario} strokeWidth="2"/>
                  <rect x="14" y="3" width="7" height="7" rx="1" stroke={colors.primario} strokeWidth="2"/>
                  <rect x="3" y="14" width="7" height="7" rx="1" stroke={colors.primario} strokeWidth="2"/>
                  <rect x="14" y="14" width="7" height="7" rx="1" stroke={colors.primario} strokeWidth="2"/>
                </svg>
              </div>
            </div>
            <span className="quick-action-label">Services</span>
          </div>
          <div className="quick-action-item">
            <div className="quick-action-icon">
              <div className="icon-circle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke={colors.primario} strokeWidth="2"/>
                  <path d="M9 12l2 2 4-4" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <span className="quick-action-label">Collect</span>
          </div>
        </div>

        {/* My Cards Section */}
        <div className="landing-cards-section">
          <div className="cards-header">
            <h2 className="cards-title">My Cards</h2>
            <div className="cards-actions">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke={colors.primario} strokeWidth="2"/>
                <circle cx="12" cy="12" r="3" stroke={colors.primario} strokeWidth="2"/>
                <path d="M2 2l20 20" stroke={colors.primario} strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="5" r="1.5" fill="#374151"/>
                <circle cx="12" cy="12" r="1.5" fill="#374151"/>
                <circle cx="12" cy="19" r="1.5" fill="#374151"/>
              </svg>
            </div>
          </div>
          {colors.url_card ? (
            <div className="credit-card-image-wrapper" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
              <img src={colors.url_card} alt="Credit Card" className="credit-card-image" />
            </div>
          ) : (
            <div className="credit-card" style={{ background: `linear-gradient(135deg, #D4A574 0%, #C9956C 100%)`, cursor: 'pointer' }} onClick={handleCardClick}>
              <div className="card-header-row">
                <span className="card-brand">VISA</span>
                <div className="card-number-preview">Credit **** **** **** 9160</div>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9l6 6 6-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="card-details-row">
                <div className="card-balance-info">
                  <span className="card-balance-label">$ 5.93</span>
                  <span className="card-balance-sub">Available</span>
                </div>
                <div className="card-date-info">
                  <span className="card-date-label">04/2028</span>
                  <span className="card-date-sub">Pay date</span>
                </div>
              </div>
              <div className="card-actions-row">
                <button className="btn-more-details">
                  More details
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18l6-6-6-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button className="btn-cvv">
                  CVV
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="11" r="8" stroke="white" strokeWidth="2"/>
                    <path d="M21 21l-4.35-4.35" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Bottom Dot Pattern */}
        <div className="landing-dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Bottom Navigation */}
        <div className="landing-bottom-nav">
          <div className="nav-item active">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke={colors.primario} strokeWidth="2"/>
            </svg>
            <span style={{ color: colors.primario }}>Home</span>
          </div>
          <div className="nav-item">
            <svg width="24" height="24" viewBox="0 0 59.1 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M58.7,83.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-2.7-2.8-4.8-6.1-6.4-9.8c-0.2-0.6-0.8-1-1.4-1h-1.3h-5.8H20.6l36.6-46.9c0.2-0.3,0.3-0.6,0.3-1v-9.1c0-0.9-0.7-1.6-1.6-1.6H38.8h-0.7h-2V0.8c0-0.4-0.4-0.8-0.8-0.8H35h-0.3H23.9h-0.4h-0.3c-0.4,0-0.8,0.4-0.8,0.8v13.1h-2.8H19H3.1c-0.9,0-1.6,0.7-1.6,1.6V26c0,0.9,0.7,1.6,1.6,1.6h33.6L0.3,74C0.1,74.3,0,74.7,0,75v9.5c0,0.9,0.7,1.6,1.6,1.6h20.9v13.1c0,0.4,0.4,0.8,0.8,0.8h0.3H24h10.8H35h0.4c0.4,0,0.8-0.4,0.8-0.8V86.1H45h11.3h1.3c0.6,0,1.2-0.4,1.4-1C59.3,84.6,59.1,83.9,58.7,83.4" fill="#9CA3AF"/>
            </svg>
            <span>Zelle</span>
          </div>
          <div className="nav-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="#9CA3AF" strokeWidth="2"/>
            </svg>
            <span>Global Transfer</span>
          </div>
          <div className="nav-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="#9CA3AF" strokeWidth="2"/>
              <path d="M3 10h18M7 15h4" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>Checks</span>
          </div>
          <div className="nav-item" onClick={handleSignOut} style={{ cursor: 'pointer' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Log out</span>
          </div>
        </div>
      </div>
    </div>
  );
};
